import React from 'react'

import Navbar from "./components/Navbar"
import Hero from "./components/Hero"
import History from "./components/History"
import Footer from "./components/Footer"

const App = () => {
    return (
        <>
            <Navbar />
            <Hero />
            <History />
            <Footer />
        </>
    )
}

export default App